import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerCodeCheck = () => {
  const customerId = useCustomerId()

  return useQuery({
    queryKey: ['customer', customerId, 'code_check'],
    queryFn: () => get(`/customers/${customerId}/code_check?`),
  })
}
